
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"91","height":"91","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M73.431 17.57L18.428 72.573M85 45.5C85 67.315 67.315 85 45.5 85S6 67.315 6 45.5 23.685 6 45.5 6 85 23.685 85 45.5z"}})])
          )
        }
      }
    